import React from "react";
import conversions from "../../assets/images/wonders.jpg";
const Help = ({heading,content}) => {
  return (
    <>
      <section class="keyzi_content--wrapper">
        <div class="container">
          <div class="keyzi_content--inner">
            <div class="row">
              <div class="col-md-12">
                <div class="card p-4">
                  <div class="row">
                    <div class="col-md-8">
                    <div dangerouslySetInnerHTML={{ __html: content?.[0]?.description }} />
                    </div>
                    <div class="col-md-4">
                      <img
                        src={`https://keyzi.com.au/keyzi-admin/public${content?.[0]?.image}`}
                        alt="International Licence Conversions"
                        class="img-fluid"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Help;
